module.exports = __webpack_public_path__ + "media/combosmash-gameplay@md-5b8f79d8bba0f0da36ca034a62dbbdb5.gif";